async function checkAndRequestLocation(allStores) {
    const savedCity = getCookie("city");
    const savedState = getCookie("state");
    const savedZip = getCookie("zipcode");
    const savedData = sessionStorage.getItem("locationData");

    // console.log('triggered check and request')
    // let zipLatLon = await getLatLon(savedZip)
    // console.log('Zip lat long  ', zipLatLon)
    // let orderedStores = await sortStores(allStores, zipLatLon)
    // console.log('ordered stores ', orderedStores)


    if (savedCity == null && savedZip == null) {
        // On initial page load, directly request geolocation without permission check
        requestGeolocationDirect();
        } else {
            // Update displays with saved location
            updateLocationDisplay(savedCity, savedState, savedZip, allStores);
            if (savedData) {
                const parsedData = JSON.parse(savedData);
            }
    }
}

function updateLocationDisplay(city, state, zipcode, allStores) {
    // Desktop display (in header)
    const cityDisplay = document.getElementById("closest-city");
    const zipDisplay = document.getElementById("closest-zip");

    if (cityDisplay) {
        cityDisplay.textContent = `${city}, ${state}`;
    }
    if (zipDisplay) {
        zipDisplay.textContent = `${zipcode}`;
    }

    // Mobile display (banner below header)
    const mobileBanner = document.getElementById("mobile-location-banner");
    if (mobileBanner) {
        mobileBanner.innerHTML = `
      <div style="background: #FFF;color:#60285f; padding: 8px 15px; text-align: center; font-size: 14px; cursor: pointer;" id="mobile-location-text">
        <span style="font-weight: bold;">📍 ${city}, ${state} ${zipcode}</span>
        <span style="margin-left: 8px; font-size: 12px; text-decoration: underline;">Change Location</span>
      </div>
    `;
// ! --------------------- Need to add here
        // Add click handler to mobile location text
        const mobileLocationText = document.getElementById("mobile-location-text");
        if (mobileLocationText) {
            mobileLocationText.addEventListener("click",()=> showLocationChangeModal(allStores));
        }
    }
}

function updateRetryButtonVisibility() {
    const retryButton = document.getElementById("retry-location-btn");
    const savedCity = getCookie("city");
    const savedZip = getCookie("zipcode");

    if (retryButton) {
        if (savedCity && savedZip) {
            retryButton.style.display = "none";
        } else {
            retryButton.style.display = "block";
        }
    }
}

function requestGeolocationDirect() {
    if (!navigator.geolocation) {
        // console.error("Geolocation is not supported by this browser.");
        return;
    }

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
}

async function requestGeolocationWithPermissionCheck() {
    if (!navigator.geolocation) {
        // console.error("Geolocation is not supported by this browser.");
        showGeolocationModal();
        return;
    }

    // Check if permissions API is available
    if (navigator.permissions) {
        try {
            const permission = await navigator.permissions.query({
                name: "geolocation",
            });

            if (permission.state === "denied") {
                showGeolocationModal();
                return;
            }
        } catch (error) {
            console.log(
                "Permissions API not fully supported, proceeding with geolocation request",
            );
        }
    }

    // If we get here, try the geolocation request
    navigator.geolocation.getCurrentPosition(successCallback, function (error) {
        console.log("Geolocation failed on retry, error code:", error.code);
        if (error.code === error.PERMISSION_DENIED) {
            // console.log('Permission denied on retry, showing modal');
            showGeolocationModal();
        } else {
            errorCallback(error);
        }
    });
}

function getBrowserType() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("chrome") && !userAgent.includes("edg")) {
        return "chrome";
    } else if (userAgent.includes("edg")) {
        return "edge";
    } else if (userAgent.includes("firefox")) {
        return "firefox";
    } else if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
        return "safari";
    } else {
        return "chrome";
    }
}

function getBrowserInstructions(browserType) {
    const instructions = {
        chrome: {
            name: "Chrome",
            steps: [
                "Click the lock icon (🔒) or info icon (ℹ️) in the address bar",
                'Find "Location" and click on it',
                'Select "Allow"',
                "Refresh the page",
            ],
        },
        edge: {
            name: "Microsoft Edge",
            steps: [
                "Click the lock icon (🔒) or info icon (ℹ️) in the address bar",
                'Find "Location" and click on it',
                'Select "Allow"',
                "Refresh the page",
            ],
        },
        firefox: {
            name: "Firefox",
            steps: [
                'Click the (<img src="https://cdn.shopify.com/s/files/1/0706/5898/1923/files/blocked_location.png?v=1758739675" alt="info icon" style="width: 16px; height: 16px; vertical-align: middle;">) icon in the address bar',
                'Click to remove the "Blocked Temporarily" to clear this permission',
                "Refresh the page",
            ],
        },
        safari: {
            name: "Safari",
            steps: [
                'Go to Safari menu → "Settings > select Websites tab"',
                'Find "Location", select this website and choose "Allow"',
                "Refresh the page",
            ],
        },
    };

    return instructions[browserType] || instructions.chrome;
}

function showGeolocationModal() {
    const existingModal = document.getElementById("geolocation-modal");
    if (existingModal) {
        existingModal.remove();
    }

    const browserType = getBrowserType();
    const browserInstructions = getBrowserInstructions(browserType);

    const modal = document.createElement("div");
    modal.id = "geolocation-modal";
    modal.innerHTML = `
        <div style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
            ">
            <div style="
                    background: white;
                    border-radius: 8px;
                    padding: 30px;
                    max-width: 500px;
                    max-height: 80vh;
                    overflow-y: auto;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                    position: relative;
                ">
                <button id="close-modal" style="
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: none;
                    border: none;
                    font-size: 24px;
                    cursor: pointer;
                    color: #666;
                ">&times;</button>

                <h4 style="margin-top: 0; color: #333;">Enable Location Services</h4>

                <p style="color: #666; margin-bottom: 20px;">
                    Location access is currently blocked. To enable location services in ${browserInstructions.name}:
                </p>

                <ol style="color: #666; line-height: 1.8; margin-bottom: 30px; padding-left: 20px;">
                    ${browserInstructions.steps.map((step) => `<li style="margin-bottom: 8px;">${step}</li>`).join("")}
                </ol>

                <div style="text-align: center;">
                    <button id="modal-close-btn" style="
                    background: #60285f;
                    color: #FFF;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                ">Got it!</button>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    document.getElementById("close-modal").addEventListener("click", closeModal);
    document
        .getElementById("modal-close-btn")
        .addEventListener("click", closeModal);

    modal.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeModal();
        }
    });
}

function showLocationChangeModal(allStores) {
    const existingModal = document.getElementById("location-change-modal");
    if (existingModal) {
        existingModal.remove();
    }
    const modal = document.createElement("div");
    modal.id = "location-change-modal";
    modal.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      padding: 20px;
    ">
      <div style="
        background: white;
        border-radius: 8px;
        padding: 30px;
        max-width: 600px;
        width: 100%;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        position: relative;
      ">
        <button id="close-location-modal" style="
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
        ">&times;</button>
        
        <h3 style="margin-top: 0; color: #333; margin-bottom: 10px;">Change Your Store Location</h3>
        <p style="color: #666; margin-bottom: 20px; font-size: 14px;">
          Enter a zip code or city, state to find stores near you
        </p>
        
        <div id="location-input-container" style="margin-bottom: 20px;">
          <input 
            type="text" 
            id="location-search-input" 
            placeholder="Enter zip code or city, state"
            style="
              width: 74%;
              padding: 12px;
              font-size: 16px;
              border: 2px solid #ddd;
              border-radius: 5px;
              box-sizing: border-box;
            "
          />
            <select 
                name="distance" 
                id="location-search-distance"
                style="
                    width: 25%;
                    padding: 12px;
                    font-size: 16px;
                    border: 2px solid #ddd;
                    border-radius: 5px;
                    box-sizing: border-box;
                    line-height: 1.5;
                "
                >
                <option value="50">50 miles</option>
                <option value="100">100 miles</option>
                <option value="150">150 miles</option>
                <option value="200">200 miles</option>
            </select>
        </div>
        
        <button id="search-location-btn" style="
          background: #60285f;
          color: #FFF;
          border: none;
          padding: 12px 24px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          width: 100%;
          margin-bottom: 20px;
        ">Search</button>
        
        <div id="location-search-results" style="margin-top: 20px;">
          <!-- Results will be inserted here -->
        </div>
      </div>
    </div>
  `;

    document.body.appendChild(modal);

    document
        .getElementById("close-location-modal")
        .addEventListener("click", closeLocationModal);
    document
        .getElementById("search-location-btn")
        .addEventListener("click", () => searchStores(allStores));

    // Allow Enter key to submit search
    document
        .getElementById("location-search-input")
        .addEventListener("keypress", function (e) {
            if (e.key === "Enter") {
                searchStores(allStores);
            }
        });

    modal.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeLocationModal();
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeLocationModal();
        }
    });
}

async function searchLocation(allStores) {
    const searchInput = document.getElementById("location-search-input");
    const resultsDiv = document.getElementById("location-search-results");
    const searchValue = searchInput.value.trim();
    const searchRadius = document.querySelector(
        "#location-search-distance",
    ).value;


    if (!searchValue) {
        resultsDiv.innerHTML =
            '<p style="color: #cc0000; text-align: center;">Please enter a zip code or city, state</p>';
        return;
    }

    // Get Google Maps API key from window object (set in header)
    const googleApiKey = window.GOOGLE_MAPS_API_KEY;

    if (!googleApiKey) {
        // console.error('Google Maps API key not found');
        resultsDiv.innerHTML =
            '<p style="color: #cc0000; text-align: center;">Configuration error. Please contact support.</p>';
        return;
    }

    resultsDiv.innerHTML =
        '<p style="text-align: center; color: #666;">Searching...</p>';

    try {
        // console.log('allStores ', allStores)
        let zipLatLon = await getLatLon(savedZip)
        // console.log('Zip lat long  ', zipLatLon)
        let orderedStores = await sortStores(allStores, zipLatLon)
        // console.log('ordered stores ', orderedStores)
        // if (
        //     zipLatLon.status !== "OK" ||
        //     !zipLatLon.results ||
        //     zipLatLon.results.length === 0
        // ) {
        //     resultsDiv.innerHTML =
        //         '<p style="color: #cc0000; text-align: center;">Location not found. Please try again with a valid US address.</p>';
        //     return;
        // }

        // const location = geocodeData.results[0].geometry.location;
        // const lat = location.lat;
        // const lon = location.lng;

        // let getAllStores = document.querySelector('.allStores')
        // console.log('all stores ', getAllStores)

        // Now search for stores using the coordinates
        // const storeUrl = `https://api.storepoint.co/v1/16723da996a0c8/locations?lat=${lat}&long=${lon}&radius=${searchRadius}`;

        // const storeResponse = await fetch(storeUrl);

        if (!storeResponse.ok) {
            throw new Error(`HTTP error! status: ${storeResponse.status}`);
        }

        const storeData = await storeResponse.json();

        if (
            !storeData.results ||
            !storeData.results.locations ||
            storeData.results.locations.length === 0
        ) {
            resultsDiv.innerHTML =
                '<p style="color: #cc0000; text-align: center;">No stores found near this location.</p>';
            return;
        }
        
        // Display store results
        // console.log("store data results ", storeData.results.locations)
        displayStoreResults(storeData.results.locations, resultsDiv);
    } catch (error) {
        // console.error('Error searching location:', error);
        resultsDiv.innerHTML =
            '<p style="color: #cc0000; text-align: center;">Error searching for stores. Please try again.</p>';
    }
}

function calcDistance(lat1, lon1, lat2, lon2) {
    try {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1); // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        let dis = d * 0.62137119; //distance in miles
        return dis;
    } catch (e) {
        console.error(e);
    }
    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }
}

function displayStoreResults(locationsInput, resultsDiv, searchRadius) {
    let locations = locationsInput.filter(loc => loc.distance <= parseFloat(searchRadius)).slice(0, 5)
    // console.log('locations ', locations)
    let locLength = locations.length
    // console.log('loclen ', locLength)
    if (locLength > 0) {
        let html =
            '<h4 style="color: #333; margin-bottom: 15px;">Select Your Store:</h4>';

        // console.log("display store locations", )

        locations.forEach((location, index) => {
            const addr = location.street;
            // const match = addr.match(/,\s*([^,]+),\s*(\w{2})\s*(\d{5})/);
            // console.log("is match ", match)
            const distance = location.distance;

            const city = location.city;
            const state = location.state;
            const zipCode = location.zipcode;


            html += `
                <div style="
                border: 1px solid #ddd;
                border-radius: 5px;
                padding: 15px;
                margin-bottom: 10px;
                cursor: pointer;
                transition: all 0.2s;
                " 
                class="store-result-item"
                data-city="${city}"
                data-state="${state}"
                data-zipcode="${zipCode}"
                onmouseover="this.style.backgroundColor='#f5f5f5'"
                onmouseout="this.style.backgroundColor='white'"
                >
                <div style="display: flex; justify-content: space-between; align-items: start; flex-wrap: wrap;">
                    <div style="flex: 1; min-width: 200px;">
                    <div style="font-weight: bold; color: #333; margin-bottom: 5px;">${location.showroom || "Store"}</div>
                    <div style="color: #666; font-size: 14px;">${addr}</div>
                    ${distance ? `<div style="color: #999; font-size: 12px; margin-top: 5px;">${distance.toFixed(2)} miles away</div>` : ""}
                    </div>
                    <button 
                    class="set-store-btn"
                    data-city="${city}"
                    data-state="${state}"
                    data-zipcode="${zipCode}"
                    style="
                        background: #60285f;
                        color: #FFF;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 5px;
                        cursor: pointer;
                        font-size: 14px;
                        white-space: nowrap;
                        margin-top: 5px;
                    "
                    >Set as My Store</button>
                </div>
                </div>
            `;

        });

        resultsDiv.innerHTML = html;
    } else {
        resultsDiv.innerHTML =
            '<p style="color: #cc0000; text-align: center;">No stores found near this location.</p>';
    }

    // Add click handlers to all "Set as My Store" button
    const setStoreButtons = resultsDiv.querySelectorAll(".set-store-btn");
    setStoreButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
            e.stopPropagation();
            const city = this.getAttribute("data-city");
            const state = this.getAttribute("data-state");
            const zipcode = this.getAttribute("data-zipcode");
            setUserStore(city, state, zipcode);
        });
    });
}

function setUserStore(city, state, zipcode) {
    // Set cookies
    setLocationCookie("city", city, 1);
    setLocationCookie("state", state, 1);
    setLocationCookie("zipcode", zipcode, 1);

    // Update displays
    updateLocationDisplay(city, state, zipcode);

    // Update button visibility
    updateRetryButtonVisibility();

    // Close modal
    closeLocationModal();

    // Check if we're on a product page
    const isProductPage = checkIfProductPage();

    if (isProductPage) {
        // Show loading message before refresh
        showConfirmation("Updating location and refreshing page...", 2000);

        // Wait a moment for the message to be visible, then refresh
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    } else {
        // Not on product page, just show confirmation
        showConfirmation(`Your store has been set to ${city}, ${state} ${zipcode}`);
    }
}

function isInShopifyCustomizer() {
    // Method 1: Check for Shopify.designMode (most reliable)
    if (typeof Shopify !== "undefined" && Shopify.designMode === true) {
        console.log("Customizer detected: Shopify.designMode");
        return true;
    }

    // Method 2: Check for Shopify customizer URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preview_theme_id")) {
        console.log("Customizer detected: preview_theme_id parameter");
        return true;
    }

    // Method 3: Check for customizer-specific URL parameters (be more specific)
    if (
        (urlParams.has("_ab") || urlParams.has("_fd") || urlParams.has("_sc")) &&
        window.location.hostname.includes("myshopify.com")
    ) {
        console.log(
            "Customizer detected: customizer parameters on myshopify domain",
        );
        return true;
    }

    // Method 4: Check for iframe ONLY if it's a Shopify admin iframe
    if (window.self !== window.top) {
        try {
            // Try to access parent hostname - if we can, and it's admin.shopify.com, we're in customizer
            if (window.parent.location.hostname.includes("admin.shopify.com")) {
                console.log("Customizer detected: iframe from admin.shopify.com");
                return true;
            }
        } catch (e) {
            // Cross-origin error means we can't check parent
            // This is probably NOT the customizer since Shopify customizer should allow access
            console.log(
                "Iframe detected but cannot verify parent origin - assuming NOT customizer",
            );
        }
    }

    // console.log('Not in customizer');
    return false;
}

function checkIfProductPage() {
    // CRITICAL: Don't refresh if we're in the Shopify theme customizer
    const inCustomizer = isInShopifyCustomizer();
    // console.log('Is in customizer?', inCustomizer);

    if (inCustomizer) {
        return false;
    }

    // Method 1: Check URL path for /products/
    if (window.location.pathname.includes("/products/")) {
        console.log("Product page detected: URL path");
        return true;
    }

    // Method 2: Check for Shopify's product object
    if (
        typeof window.ShopifyAnalytics !== "undefined" &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.page &&
        window.ShopifyAnalytics.meta.page.pageType === "product"
    ) {
        console.log("Product page detected: ShopifyAnalytics");
        return true;
    }

    // Method 3: Check for common product page elements
    if (
        document.querySelector(".product-template") ||
        document.querySelector('[data-section-type="product"]') ||
        document.querySelector(".product-single") ||
        document.querySelector("#ProductSection")
    ) {
        console.log("Product page detected: DOM elements");
        return true;
    }

    // Method 4: Check meta property
    const metaPageType = document.querySelector('meta[property="og:type"]');
    if (metaPageType && metaPageType.content === "product") {
        console.log("Product page detected: meta tag");
        return true;
    }

    // Method 5: Check for product JSON-LD
    const jsonLdScripts = document.querySelectorAll(
        'script[type="application/ld+json"]',
    );
    for (let script of jsonLdScripts) {
        try {
            const data = JSON.parse(script.textContent);
            if (data["@type"] === "Product") {
                console.log("Product page detected: JSON-LD");
                return true;
            }
        } catch (e) {
            // Skip invalid JSON
        }
    }
    return false;
}

function showConfirmation(message, duration = 3000) {
    const confirmation = document.createElement("div");
    confirmation.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #4CAF50;
    color: white;
    padding: 15px 25px;
    border-radius: 5px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    z-index: 10001;
    font-size: 16px;
    animation: slideDown 0.3s ease-out;
  `;
    confirmation.textContent = message;

    document.body.appendChild(confirmation);

    setTimeout(() => {
        confirmation.style.animation = "slideUp 0.3s ease-out";
        setTimeout(() => {
            confirmation.remove();
        }, 300);
    }, duration);
}

function closeModal() {
    const modal = document.getElementById("geolocation-modal");
    if (modal) {
        modal.remove();
    }
}

function closeLocationModal() {
    const modal = document.getElementById("location-change-modal");
    if (modal) {
        modal.remove();
    }
}

function successCallback(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    const url = `https://api.storepoint.co/v1/16723da996a0c8/locations?lat=${latitude}&long=${longitude}&radius=100`;

    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            sessionStorage.setItem("locationData", JSON.stringify(data));
            const addr = data.results.locations[0].streetaddress;
            const match = addr.match(/,\s*([^,]+),\s*(\w{2})\s*(\d{5})/);

            if (match) {
                const city = match[1];
                const state = match[2];
                const zipCode = match[3];

                setLocationCookie("city", city, 1);
                setLocationCookie("state", state, 1);
                setLocationCookie("zipcode", zipCode, 1);

                updateLocationDisplay(city, state, zipCode);
                updateRetryButtonVisibility();

                // Check if we're on a product page and refresh if needed
                const isProductPage = checkIfProductPage();

                if (isProductPage) {
                    // Show loading message before refresh
                    showConfirmation("Location detected! Refreshing page...", 2000);

                    // Wait a moment for the message to be visible, then refresh
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            }
        })
        .catch((error) => {
            console.log("Error fetching data: ", error);
        });
}

function setLocationCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;

    const isSecure =
        location.protocol === "https:" || location.hostname === "localhost";
    const secureFlag = isSecure ? "Secure; " : "";

    const cookieString = `${name}=${value}; ${expires}; path=/; SameSite=Lax; ${secureFlag}`;
    document.cookie = cookieString;
}

function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(nameEQ)) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}

function errorCallback(error) {
    console.error("Error getting geolocation:", error);

    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error("Location access denied by user");
            break;
        case error.POSITION_UNAVAILABLE:
            console.error("Location unavailable");
            break;
        case error.TIMEOUT:
            console.error("Location request timed out");
            break;
        default:
            console.error("Unknown location error");
            break;
    }
}

function sortStores(allStores, zipLatLon) {
    try {
        let locLat = zipLatLon.lat
        let locLon = zipLatLon.lng
        let storeDis = []
        // console.log('all stores in sort ', allStores)
        allStores.forEach(s => {
            let sLat = parseFloat(s.lat);
            // console.log("slat typeof ", sLat)
            let sLon = parseFloat(s.lon)
            let distance = calcDistance(locLat, locLon, sLat, sLon)
            s.distance = distance
            storeDis.push(s)
        })
        let orderedStores = storeDis.sort((a, b) => a.distance - b.distance)
        return orderedStores
    } catch (e) {
        console.error(e)
    }
}

function getLatLon(zip){
    let apiKey = 'AIzaSyD0P9B1fDKbgn-pqvG6Lho24AN9ZBNH6ZE';
    // let apiKey = window.GOOGLE_MAPS_API_KEY;
    const url =  `https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=${apiKey}`;

    return fetch(url)
    .then(response => response.json())
    .then(data => {
        // console.log()
        if (data.status === 'OK') {
            const { lat, lng } = data.results[0].geometry.location;
            // console.log(`Latitude: ${lat}, Longitude: ${lng}`);
            return { lat, lng }
        } else {
            console.error('Geocoding failed:', data.status);
        }
    });

}

async function searchStores(allStores){

    const zipInput = document.querySelector('#location-search-input').value;
    const savedData = sessionStorage.getItem("locationData");
    const searchInput = document.getElementById("location-search-input");
    const resultsDiv = document.getElementById("location-search-results");
    const searchValue = searchInput.value.trim();
    const searchRadius = document.querySelector(
        "#location-search-distance",
    ).value;


    if (!searchValue) {
        resultsDiv.innerHTML =
            '<p style="color: #cc0000; text-align: center;">Please enter a zip code or city, state</p>';
        return;
    }
    
    // console.log('allStores ', allStores)
    let zipLatLon = await getLatLon(zipInput)
    // console.log('Zip lat long  ', zipLatLon)
    let orderedStores = await sortStores(allStores, zipLatLon)
    // console.log('ordered stores ', orderedStores)
    displayStoreResults(await orderedStores, resultsDiv, searchRadius) 

}